var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_532_4739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.425 3.95686C7.94125 3.83601 8.4698 3.77561 9 3.77686C14.25 3.77686 17.25 9.77686 17.25 9.77686C16.7947 10.6286 16.2518 11.4304 15.63 12.1694M10.59 11.3669C10.384 11.5879 10.1356 11.7652 9.85961 11.8882C9.58362 12.0112 9.28568 12.0773 8.98357 12.0826C8.68146 12.088 8.38137 12.0324 8.10121 11.9192C7.82104 11.8061 7.56654 11.6376 7.35288 11.424C7.13923 11.2103 6.97079 10.9558 6.85763 10.6756C6.74447 10.3955 6.68889 10.0954 6.69423 9.79329C6.69956 9.49118 6.76568 9.19324 6.88866 8.91724C7.01163 8.64124 7.18894 8.39284 7.41 8.18686M0.75 1.52686L17.25 18.0269M13.455 14.2319C12.1729 15.2091 10.6118 15.7505 9 15.7769C3.75 15.7769 0.75 9.77686 0.75 9.77686C1.68292 8.03828 2.97685 6.51931 4.545 5.32186L13.455 14.2319Z",
    stroke: "#97A7C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_532_4739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.776855)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.71cb5b12543bde6416c9e08e74b89cbe.svg";
export { ForwardRef as ReactComponent };